import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// DON NOT REMOVE the comments around 'import style.scss'
// ###STYLE_REPLACEMENT_START###
import './style.scss'
// ###STYLE_REPLACEMENT_END###

const Checkbox = ({ id, label, onChange, inversed, extraClasses, checked, indeterminate, disabled, ...restProps }) => {
  const handleChange = (e) => {
    onChange(e.target.checked)
  }

  return (
    <div
      className={classnames('gdpp-component fil-checkbox', {
        [extraClasses]: extraClasses,
        [`fil-checkbox--inversed`]: inversed
      })}
    >
      <input
        type="checkbox"
        className="fil-checkbox__field"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        {...(indeterminate ? { indeterminate: indeterminate.toString() } : {})}
        {...restProps}
      />
      <label id={`fil-checkbox__label-${id}-${label}`} className="fil-checkbox__label" htmlFor={id}>
        {label}
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  extraClasses: PropTypes.string,
  inversed: PropTypes.bool,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool
}

Checkbox.defaultProps = {
  label: '',
  onChange: () => {},
  extraClasses: '',
  inversed: false,
  checked: false,
  indeterminate: false,
  disabled: false
}

export default Checkbox
